import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import { Container, Row, Col, Form, Button } from "react-bootstrap"
import parse from "html-react-parser"
import "../Valuation/ValuationForm/ValuationForm.scss"

import Contact from "../forms/contact-form"

const ContactLanding = (props) => {
  const [alias, setAlias] = useState('');
  const [formtype, setFormType] = useState('');

  useEffect(async () => {
    if (localStorage.getItem('page-alias')) {
      setAlias(localStorage.getItem('page-alias'))
    }
    
    const pageurl = typeof window !== 'undefined' ? window.location.href : ''
    var pageval = new URL(pageurl)
    var typeval = pageval.searchParams.get("type")
    if(typeval) {
      setFormType(typeval)
    }
  }, []);

  var bg_img = ''
  if(props.page.Banner_Image) {
    bg_img = props.page.Banner_Image.url
  }

    return (
        <React.Fragment>
          <section className="valuation-page" style={{background:"url(" + bg_img + ")"}}>
            <div className="page">
              <Container>
                <Row>
                  <Col md='12' lg={7}>
                    {parse(props.page.Banner_Content)}
                  </Col>
                </Row>
                <Row>
                  <Col md='12' lg={8}>
                    <div className="valuation-form contact-main-form">
                        <div className="main-calc">
                            <div className="form-wrapper">
                                <Contact alias={alias} formtype={formtype}/>
                            </div>
                        </div>
                    </div>
              </Col>
              <Col lg={4} className="d-none d-lg-block">
                
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </React.Fragment >
    )
}

export default ContactLanding